<div class="wifi-signal-container">
  <div class="signal-bars">
    <div 
      *ngFor="let bar of signalBars; let i = index" 
      [class]="getBarClass(i)"
      class="signal-bar">
    </div>
  </div>
  <span *ngIf="showText" class="signal-text">{{showFullText ? signalStrength : displayText}}</span>
</div> 